import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Tab, ToastService } from '@teorema/patron';
import { Observable, Subject, Subscription } from 'rxjs';
import { FilterField, FilterOperator, Ticket, TicketLog, TicketUser, User } from 'src/app/models';
import { utils } from 'src/app/shared';
import { SortPipe } from 'src/app/shared/pipes';
import {
  ModalToggleService,
  TcCurrentLogService,
  TcDataService,
  TcSingleTicketPageUtilsService,
  TcTaskService,
  TcTicketLogService,
  TcTicketService,
  UserService,
} from 'src/app/shared/services';
import { TasksComponent } from '../../tasks/tasks.component';
import { TicketLogsModalComponent } from '../../ticket-logs-modal/ticket-logs-modal.component';
import { TsDevTabComponent } from './tabs/ts-dev-tab/ts-dev-tab.component';
import { TsInfoTabComponent } from './tabs/ts-info-tab/ts-info-tab.component';
import { TsMainTabComponent } from './tabs/ts-main-tab/ts-main-tab.component';
import { TsOthersTabComponent } from './tabs/ts-others-tab/ts-others-tab.component';
import { AuthService } from '@app/auth/auth.service';

@Component({
  selector: 'ticket-show-body',
  templateUrl: './ticket-show-body.component.html',
  styleUrls: ['./ticket-show-body.component.scss'],
  standalone: false,
})
export class TicketShowBodyComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() entity?: Ticket;
  @Input() hasConfirmation: boolean = false;
  @Input() loading?: boolean;
  @Input() isSaving?: boolean;
  @Input() showSaveButton?: boolean;
  @Input() taskId;
  @Input() showTabsBodies: boolean = false;

  @Output() saved = new EventEmitter<boolean>();
  @Output() saving = new EventEmitter<boolean>();

  unconfirmedTicket?: Ticket;
  wasValidated: boolean = false;
  defaultPageSize = 200;
  saveCameFromTasksComponent?: boolean;
  @Input() user?: any;

  users?: Observable<User[]>;

  attachments = [];
  uploadingAttachments = false;

  userResp?: User;
  userDes?: User;
  userExec?: User;
  usersPart: User[] = [];

  usersInput = new Subject<string>();
  loadingUsers = false;
  confirmExpectedDateCleanVisible = false;

  initialValueformMainTab: any = null;
  initialValueformOtherTab: any = null;

  @ViewChild(TicketLogsModalComponent) ticketLogsModalComponent?: TicketLogsModalComponent;
  @ViewChild(TsInfoTabComponent) tsInfoTabComponent?: TsInfoTabComponent;
  @ViewChild(TsMainTabComponent) tsMainTabComponent?: TsMainTabComponent;
  @ViewChild(TsOthersTabComponent) tsOthersTabComponent?: TsOthersTabComponent;
  @ViewChild(TasksComponent) tasksComponent?: TasksComponent;
  @ViewChild(TsDevTabComponent) tsDevTabComponent?: TsDevTabComponent;

  //@ViewChild('tabview') tabview!: TabviewComponent

  @ViewChild('principalTemplate') principalTemplate?: TemplateRef<any>;
  @ViewChild('informacoesTemplate') informacoesTemplate?: TemplateRef<any>;
  @ViewChild('tarefasTemplate') tarefasTemplate?: TemplateRef<any>;
  @ViewChild('outrosTemplateFields') outrosTemplateFields?: TemplateRef<any>;
  @ViewChild('devTemplate') devTemplate?: TemplateRef<any>;
  @ViewChild('documentationsTemplate') documentationsTemplate?: TemplateRef<any>;

  tabs: Tab[] = [];
  activeTabIndex: number = 0;
  previousTabIndex: number = 0;

  // ticketLogsModal: BsModalRef;
  ticketLogsModalFirstClose = false;
  subscriptions: Subscription[] = [];
  logsModalData: any = {};
  logsLoaded = false;
  assemblingTicket = false;
  loadedTabs: number[] = [];
  loadingTicketLogs = false;
  unsavedDataWarningModalVisible: boolean = false;
  constructor(
    private toastService: ToastService,
    private authService: AuthService,
    private userService: UserService,
    private dataService: TcDataService,
    private ticketService: TcTicketService,
    private ticketLogService: TcTicketLogService,
    // private sortPipe: SortPipe,
    private singleTicketPageUtilsService: TcSingleTicketPageUtilsService,
    private currentTicketLogService: TcCurrentLogService,
    private sortPipe: SortPipe,
    private tcTicketLogService: TcTicketLogService,
    private zone: NgZone,
    private modalToggleService: ModalToggleService,
    private cdr: ChangeDetectorRef,
    private taskService: TcTaskService
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.tabs.push(
        ...[
          {
            index: 0,
            header: 'Principal',
            template: this.principalTemplate!,
          },
          {
            index: 1,
            header: 'Informações',
            template: this.informacoesTemplate!,
          },
          {
            index: 3,
            header: 'Outros',
            template: this.outrosTemplateFields!,
          },
        ]
      );

      if (this.isSprintCanRead()) {
        const sprintTab = {
          index: 2,
          header: 'Tarefas',
          template: this.tarefasTemplate!,
        };

        const insertIndex = this.tabs.findIndex(tab => tab?.index!! > sprintTab.index);

        if (insertIndex !== -1) {
          this.tabs.splice(insertIndex, 0, sprintTab);
        } else {
          this.tabs.push(sprintTab);
        }
      }

      if (this.isDevCanRead()) {
        const devTab = {
          index: 4,
          header: 'Desenvolvimento',
          template: this.devTemplate!,
        };

        const insertIndex = this.tabs.findIndex(tab => tab?.index!! > devTab.index);

        if (insertIndex !== -1) {
          this.tabs.splice(insertIndex, 0, devTab);
        } else {
          this.tabs.push(devTab);
        }
      }

      if (this.isDocumentationCanRead()) {
        const documentationsTab = {
          index: 5,
          header: 'Documentações',
          template: this.documentationsTemplate!,
        };

        const insertIndex = this.tabs.findIndex(tab => tab?.index!! > documentationsTab.index);

        if (insertIndex !== -1) {
          this.tabs.splice(insertIndex, 0, documentationsTab);
        } else {
          this.tabs.push(documentationsTab);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => {
      s.unsubscribe();
    });
  }

  ngOnInit(): void {
    // this.singleTicketPageUtilsService.getUsers(this);
    // this.singleTicketPageUtilsService.getTicketStatuses(this);

    // this.modalService.onHide.subscribe(() => {
    //   if (this.ticketSaveConfirmationModal) {
    //     this.dataService.ticketUpdateConfirmationEmitter.emit(this.ticketSaveConfirmationModal.content.confirmed);

    //     if (this.ticketSaveConfirmationModal.content.confirmed) {
    //       this.confirmTicketSave();
    //     }

    //     this.ticketSaveConfirmationModal = null;
    //   }

    //   if (this.cleanExpectedDateConfirmationModal && this.cleanExpectedDateConfirmationModal.content.confirmation) {
    //     this.confirmExpectedDateClean();
    //   }

    //   if (this.ticketLogsModal) {
    //     if (this.ticketLogsModalFirstClose) {
    //       this.dataService.loadTaskProgressEmitter.emit(true);
    //     }

    //     this.ticketLogsModalFirstClose = true;
    //     this.ticketLogsModal = null;
    //   }

    //   this.cleanExpectedDateConfirmationModal = null;
    // });

    this.subscriptions.push(
      this.dataService.ticketUpdateConfirmationEmitter.subscribe(confirmed => {
        if (!confirmed) {
          this.saving.emit(false);
          /*let tempTasks = undefined;

          if (this.saveCameFromTasksComponent) {
            tempTasks = this.unconfirmedTicket.tasks;
          }*/

          this.dataService.assembleTicketEmitter!.emit(this.entity);

          /*setTimeout(() => {
            if (tempTasks) {
              this.unconfirmedTicket.tasks = tempTasks;
              this.confirmTicketSave();
            }
          }, 100);*/
        }
      })
    );

    this.subscriptions.push(
      this.currentTicketLogService.startedTicketLogEmitter.subscribe(ticketLog => {
        if (!this.openedLogs.find(tl => tl.id === ticketLog.id)) {
          this.openedLogs.push(ticketLog);
        }
      })
    );

    this.subscriptions.push(
      this.currentTicketLogService.stoppedTicketLogEmitter.subscribe(ticketLog => {
        this.removeOpenedLog(ticketLog);
      })
    );

    this.subscriptions.push(
      this.dataService.openTicketLogsModalEmitter.subscribe(task => {
        this.openTicketLogsModal(task);
      })
    );
  }

  unsavedDataWarningModal() {
    this.unsavedDataWarningModalVisible = true;
  }

  assembleTicket(entityParam: Ticket) {
    this.entity = entityParam;

    this.dataService.addTicketToRecentlyViewedTickets(this.entity!!.id);
    this.assemblingTicket = true;
    // this.dataService.addTicketToRecentlyViewedTickets(this.entity.id);
    this.sortTicketDocuments(this.entity!!);
    // if (this.entity?.expected_date) {
    //   this.expectedDateString = new Date(this.entity.expected_date)
    //     .toJSON()
    //     .slice(0, 10);
    // }

    // if (this.entity?.analysisExpectedDate) {
    //   this.entity.analysisExpectedDate = new Date(this.entity.analysisExpectedDate).toJSON().slice(0, 10)
    // }

    // if (this.entity.developmentExpectedDate) {
    //   this.entity.developmentExpectedDate = new Date(this.entity.developmentExpectedDate).toJSON().slice(0, 10)
    // }
    this.setTicketUsers();

    this.setTicketUsers();

    // Ensure components are ready before mounting logic
    const attemptMount = (count = 0) => {
      // Limit retries to avoid infinite loop (e.g. 50 * 50ms = 2.5s timeout)
      if ((!this.tsMainTabComponent || !this.tsOthersTabComponent) && count < 50) {
        setTimeout(() => attemptMount(count + 1), 50);
        return;
      }

      this.zone.run(async () => {
        try {
          console.log('Mounting Main Tab...');
          this.tsMainTabComponent?.mountFormGroupMainTab(this.entity!);

          this.assemblingTicket = false;

          console.log('Mounting Others Tab...');
          this.tsOthersTabComponent?.mountFormGroupOtherTab(this.entity!);

          console.log('Loading Ticket Log...');
          await this.loadTicketLog();

          if (this.tasksComponent) {
            this.tasksComponent.currentTask = undefined;
          }

          this.tasksComponent?.setEfforts();
        } catch (error) {
          console.error('Error during ticket assembly:', error);
        } finally {
        }
      });

      this.initialValueformMainTab = this.tsMainTabComponent?.getTicketForm().getRawValue();
      this.initialValueformOtherTab = this.tsOthersTabComponent?.getTicketForm().getRawValue();
    };

    attemptMount();
  }

  resetTicketlogsLoaded() {
    this.logsLoaded = false;
  }

  async setUserValues() {
    // aqui está demorando na primeira vez aparentemente
    if (!this.user) {
      this.user = await this.userService.getCurrentUser().catch(e => {
        console.error(e);
        this.toastService.show({
          color: 'error',
          message: 'Houve um erro ao carregar os dados',
        });
      });
    }

    if (this.tasksComponent) {
      this.tasksComponent!.loadTasksProgress(this.entity!);
    }
  }

  tasksTabClicked() {
    if (this.tasksComponent) {
      this.tasksComponent.loadTasksProgress(this.entity!, true);
    }
  }

  saveTicket(params?: any) {
    if (!this.entity!.ref) {
      this.toastService.show({
        color: 'error',
        message: 'O chamado ainda não foi sincronizado. Tente novamente mais tarde.',
      });
      this.saving.emit(false);
      return;
    }

    //this.assembleUnconfirmedTicket();
    this.saveCameFromTasksComponent = params?.saveCameFromTasksComponent;

    this.prepareToSave();

    if (this.dataService.shouldRecalculateTaskEffort && this.getTotalEffort(this.entity) > 0) {
      this.entity!.estimated_effort = this.getTotalEffort(this.entity);
    }

    if (this.tasksComponent) {
      this.entity!.expected_date = this.taskService.getLastExpectedDate(this.entity);
    }
    // if (this.hasConfirmation) {
    //   this.openTicketSaveConfirmationModal();
    // } else {
    this.dataService.ticketUpdateConfirmationEmitter.emit(true);
    this.confirmTicketSave();
    // }
  }

  getTotalEffort(ticket?: Ticket) {
    let result = 0;
    if (ticket?.tasks) {
      ticket!.tasks!.forEach(task => {
        result += parseFloat(task.estimated_effort + '');
      });
    }
    return result;
  }

  async confirmTicketSave() {
    this.saving.emit(true);

    let response = await this.ticketService.save(this.entity!).catch(() => {
      this.toastService.show({
        color: 'error',
        message: 'Houve um erro ao salvar',
      });
      this.saving.emit(false);
    });

    if (response?.id) {
      this.saved.emit(true);
      this.saving.emit(false);
      this.toastService.show({
        color: 'success',
        message: 'Chamado editado com sucesso!',
      });
      this.dataService!.assembleTicketEmitter!.emit(response!);
    }
  }

  isObject(valeu: any): boolean {
    if (typeof valeu == 'object') {
      return true;
    } else {
      return false;
    }
  }

  prepareToSave() {
    if (
      this.userResp &&
      !this.entity!.ticketUsers!.filter(ticketUser => {
        return (
          ticketUser.user_type === 'R' &&
          ticketUser.user &&
          ticketUser.user.id === this.userResp!.id
        );
      }).length
    ) {
      this.entity!.ticketUsers = this.entity!.ticketUsers!.filter(
        ticketUser => ticketUser.user_type !== 'R'
      );

      let ticketUser = new TicketUser();
      ticketUser.user = this.userResp;
      ticketUser.user_type = 'R';
      this.entity!.ticketUsers.push(ticketUser);
    } else if (!this.userResp) {
      this.entity!.ticketUsers = this.entity!.ticketUsers!.filter(
        ticketUser => ticketUser.user_type !== 'R'
      );
    }

    if (
      this.userDes &&
      !this.entity!.ticketUsers!.filter(ticketUser => {
        return (
          ticketUser.user_type === 'D' && ticketUser.user && ticketUser.user.id === this.userDes!.id
        );
      }).length
    ) {
      this.entity!.ticketUsers = this.entity!.ticketUsers!.filter(
        ticketUser => ticketUser.user_type !== 'D'
      );

      let ticketUser = new TicketUser();
      ticketUser.user = this.userDes;
      ticketUser.user_type = 'D';
      this.entity!.ticketUsers.push(ticketUser);
    } else if (!this.userDes) {
      this.entity!.ticketUsers = this.entity!.ticketUsers!.filter(
        ticketUser => ticketUser.user_type !== 'D'
      );
    }

    if (
      this.userExec &&
      !this.entity!.ticketUsers!.filter(ticketUser => {
        return (
          ticketUser.user_type === 'E' &&
          ticketUser.user &&
          ticketUser.user.id === this.userExec!.id
        );
      }).length
    ) {
      this.entity!.ticketUsers = this.entity!.ticketUsers!.filter(
        ticketUser => ticketUser.user_type !== 'E'
      );

      let ticketUser = new TicketUser();
      ticketUser.user = this.userExec;
      ticketUser.user_type = 'E';
      this.entity!.ticketUsers.push(ticketUser);
    } else if (!this.userExec) {
      this.entity!.ticketUsers = this.entity!.ticketUsers!.filter(
        ticketUser => ticketUser.user_type !== 'E'
      );
    }

    if (this.usersPart) {
      this.usersPart.forEach(userPart => {
        if (
          !this.entity!.ticketUsers!.filter(ticketUser => {
            return (
              ticketUser.user_type === 'P' && ticketUser.user && ticketUser.user.id === userPart.id
            );
          }).length
        ) {
          let ticketUser = new TicketUser();
          ticketUser.user = userPart;
          ticketUser.user_type = 'P';
          this.entity!.ticketUsers!.push(ticketUser);
        }
      });

      let newTicketUsers: any[] = [];
      this.entity!.ticketUsers!.forEach(ticketUser => {
        if (
          ticketUser.user_type != 'P' ||
          (ticketUser.user! && this.usersPart.filter(up => up.id === ticketUser.user!.id)).length
        ) {
          newTicketUsers.push(ticketUser);
        }
      });
      this.entity!.ticketUsers = newTicketUsers;
    }

    // this.singleTicketPageUtilsService.convertStringsToTags(this.tsOthersTabComponent, this.unconfirmedTicket, this.user.companyGroup);
    // this.singleTicketPageUtilsService.convertStringsToTags(null, this.entity!, this.user!.company_group!);

    this.tsMainTabComponent!.prepareToSave();
    this.tsOthersTabComponent!.prepareToSave();
  }

  sortTicketDocuments(ticket: Ticket) {
    if (!ticket.documents) {
      ticket.documents = [];
    }

    ticket.documents = this.sortPipe.transform(ticket.documents, 'created_at');
  }

  save() {
    if (this.areAllFormsValid()) {
      this.saving.emit(true);

      this.saveTicket();
      // if (this.attachments && this.attachments.length) {
      //   this.singleTicketPageUtilsService.uploadAttachments(this, this.unconfirmedTicket, event.newMessage, this.user.companyGroup)
      // } else {
      //   this.saveTicket({ newMessage: event.newMessage })
      // }
    } else {
      this.wasValidated = true;
      this.toastService.show({
        color: 'error',
        message: 'Formulário inválido. Verifique os campos!',
      });
    }
  }

  areAllFormsValid(): boolean {
    return this.tsMainTabComponent!.isFormValid() && this.tsOthersTabComponent!.isFormValid();
  }

  ticketLogs: TicketLog[] = [];
  openedLogs: TicketLog[] = [];

  async loadTicketLog() {
    if (this.logsLoaded) return;
    this.loadingTicketLogs = true;

    this.openedLogs = [];
    let findOptions = {
      page: 1,
      perPage: 100,
      filters: [
        new FilterField({
          name: 'equal[ticket_id]',
          value: this.entity!.id,
          operator: FilterOperator.has,
          label: '',
        }),
      ],
    };

    let response = await this.tcTicketLogService.findAll(findOptions).catch(e => {
      console.error(e);
      this.toastService.show({ color: 'error', message: 'Houve um erro ao carregar os dados' });
    });

    if (response?.data) {
      this.ticketLogs = response.data;
      this.openedLogs = this.ticketLogs.filter(tl => !tl.end_date);
      this.logsLoaded = true;
      this.loadingTicketLogs = false;
    }
  }

  // openTicketSaveConfirmationModal() {
  //   const initialState = {
  //     ticket: this.unconfirmedTicket
  //   };

  //   this.ticketSaveConfirmationModal = this.modalService.show(
  //     TicketSaveConfirmationModalComponent, { initialState, class: 'modal-lg', backdrop: 'static', keyboard: false }
  //   );
  // }

  setTicketUsers() {
    this.userResp = undefined;
    this.userDes = undefined;
    this.userExec = undefined;
    this.usersPart = [];

    if (this.entity!.ticketUsers && this.entity!.ticketUsers.length) {
      this.entity!.ticketUsers.forEach(tu => {
        if (tu.user_type) {
          switch (tu.user_type) {
            case 'R': {
              if (!this.userResp) {
                this.userResp = tu.user;
              }

              break;
            }
            case 'D': {
              if (!this.userDes) {
                this.userDes = tu.user;
              }

              break;
            }
            case 'E': {
              if (!this.userExec) {
                this.userExec = tu.user;
              }

              break;
            }
            case 'P': {
              this.usersPart.push(tu.user!);
              break;
            }
            default:
              break;
          }
        }
      });
    }
  }

  tabChanged(index: number) {
    let valueModifyMainTab = this.tsMainTabComponent?.getTicketForm().getRawValue();
    let valueModifyOtherTab = this.tsOthersTabComponent?.getTicketForm().getRawValue();

    if (
      JSON.stringify(this.initialValueformMainTab) !== JSON.stringify(valueModifyMainTab) ||
      JSON.stringify(this.initialValueformOtherTab) !== JSON.stringify(valueModifyOtherTab)
    ) {
      this.unsavedDataWarningModal();
      this.activeTabIndex = index;
      this.modalToggleService.runAndDetect(() => {
        this.activeTabIndex = this.previousTabIndex;
      }, this.cdr);
      return;
    }

    this.previousTabIndex = this.activeTabIndex;

    this.activeTabIndex = index;

    if (!this.loadedTabs.includes(index)) {
      if (index === 1) {
        this.tsInfoTabComponent!.loadTicketMovementHistories();
      } else if (index === 2) {
        this.tasksTabClicked();
      } else if (index === 4) {
        this.tsDevTabComponent?.loadTabDev();
      }

      this.loadedTabs.push(index);
    }
  }

  acceptEditTicket() {
    this.unsavedDataWarningModalVisible = false;
  }

  reset() {
    this.activeTabIndex = 0;
    this.loadedTabs = [];
    this.resetTicketlogsLoaded();
    this.ticketLogsModalComponent?.reset();
  }

  cleanExpectedDate() {
    if (this.isSaving) return;

    if (!this.entity?.expected_date) {
      this.toastService.show({
        color: 'warn',
        message: 'Data de previsão já está vazia',
      });
      return;
    }

    this.confirmExpectedDateCleanVisible = false;
    this.modalToggleService.runAndDetect(() => {
      this.confirmExpectedDateCleanVisible = true;
    }, this.cdr);
  }

  async confirmExpectedDateClean() {
    if (this.isSaving) return;
    this.saving.emit(true);
    let response = await this.ticketService.patchMultiple([
      {
        id: this.entity?.id,
        expected_date: null,
      },
    ]);
    this.saving.emit(false);

    if (response?.length) {
      this.confirmExpectedDateCleanVisible = false;
      this.toastService.show({
        color: 'success',
        message: 'Data de previsão limpa com sucesso',
      });
      this.saved.emit(true);
      this.entity!.expected_date = null;

      if (this.unconfirmedTicket) {
        this.unconfirmedTicket!.expected_date = null;
      }

      this.tsOthersTabComponent!.expectedDateStringChanged(undefined);
    }
  }

  openTicketLogsModal(event?: any) {
    this.logsModalData.visible = false;
    this.logsModalData.entity = this.unconfirmedTicket || this.entity;
    this.logsModalData.user = this.user;
    this.logsModalData.taskId = this.taskId;
    this.logsModalData.inputTask = event?.task;
    this.logsModalData.inputSystem = event?.system;

    this.modalToggleService.runAndDetect(() => {
      this.logsModalData.visible = true;
    }, this.cdr);
  }

  removeOpenedLog(ticketLog: TicketLog) {
    if (ticketLog && ticketLog.ticket_id && this.entity && ticketLog.ticket_id === this.entity.id) {
      let index = this.openedLogs.findIndex(tl => tl.id === ticketLog.id);

      if (index != null && index > -1) {
        this.openedLogs.splice(index, 1);
      }
    }
  }

  logsModalClosed() {
    if (this.ticketLogsModalFirstClose) {
      this.dataService.loadTaskProgressEmitter.emit(true);
    }

    this.ticketLogsModalFirstClose = true;
  }

  isSprintCanRead() {
    return utils.checkAccess(['Sprint'], true).result;
  }

  isDevCanRead() {
    return utils.checkAccess(['Development'], true).result;
  }

  isDocumentationCanRead() {
    return utils.checkAccess(['Documentation'], true).result;
  }

  isDocumentationCanWrite() {
    return utils.checkAccess(['Documentation'], true, true).result;
  }
}
